import React, { useState } from 'react';
import SheEarnsBlankCanvas from './SheEarnsBlankCanvas';
import SheEarnsLinedCanvas from './SheEarnsLinedCanvas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faRuler, faListAlt, faTh, faList } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './SheEarnsNotesCanvas.css';
import axios from 'axios';
import { useSelector } from 'react-redux';

const canvasComponents = [
  { icon: faBook, component: SheEarnsBlankCanvas, name: 'Blank Page' },
  { icon: faRuler, component: SheEarnsLinedCanvas, name: 'Lined Page' },
];

const SheEarnsTouchBookPlain = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const [overlayContent, setOverlayContent] = useState(null);

  const handleIconClick = (Component, props = {}) => {
    setOverlayContent(() => <Component {...props} onClose={handleCloseOverlay} />);
  };

  const handleCloseOverlay = () => {
    setOverlayContent(null);
  };

  const handleBackToHome = () => {
    navigate(-1)
  };

  return (
    <div className="full-screen-overlay">
      <div className='flex flex-col'>
        <div className='flex justify-center items-center my-4'>
            <p className='text-white bg-pink-600 text-m lg:text-lg rounded-lg px-6 py-2 shadow-lg'>
                SAKSHAM Shakti Digital Plain Paper
            </p>
        </div>
        <div className="canvas-grid">
            {canvasComponents.map((item, index) => (
                <div 
                key={index} 
                className="icon text-white" 
                onClick={() => handleIconClick(item.component, item.props)}
                >
                <FontAwesomeIcon className="text-white" icon={item.icon} size="200px" />
                <p className='text-white'>{item.name}</p>
                </div>
            ))}
        </div>
        {overlayContent && (
            <div className="overlay">
            {overlayContent}
            </div>
        )}
        <div>
            <button className="bg-pink-600 text-white" onClick={handleBackToHome}>Close</button>
        </div>
    </div>
   </div>
  );
};

export default SheEarnsTouchBookPlain;

